import {Landing} from './landing.js';
export default Landing